import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IOutgoingInvoiceCreateRouteParams {
    reservationId: Guid
}

interface IOutgoingInvoiceCreateRouteQuery {
    backUrl: string
}

const OutgoingInvoiceCreateRoute = new AppRoute<IOutgoingInvoiceCreateRouteParams, IOutgoingInvoiceCreateRouteQuery>({
    route: "/outgoing-invoice/:reservationId/create",
    navbar: true,
    authRequired: true,
})

export default OutgoingInvoiceCreateRoute
